import { onUnmounted } from "vue";

function useTimer(handler, start, cancel)
{
	let id;

	onUnmounted(() => cancel(id));

	return {
		set(delay)
		{
			cancel(id);
			id = start(handler, delay);
		},
		clear()
		{
			cancel(id);
		}
	};
}

export function useInterval(handler)
{
	return useTimer(handler, setInterval, clearInterval);
}

export function useTimeout(handler)
{
	return useTimer(handler, setTimeout, clearTimeout);
}
